<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工单录入列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button
          type="info"
          icon="el-icon-magic-stick"
          @click.native="addNegative"
          >工单录入</el-button
        >
      </el-button-group>
    </el-header>
    <el-main>
      <div>
        <!-- 查询工具栏-->
        <div class="cust_seach">
          <el-input
            class="btnTitle"
            v-model="query.queryString"
            placeholder="请输入模糊字段"
          />
          <el-button-group>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="querySubmit"
            />
          </el-button-group>
        </div>
        <el-table :data="data.psts">
          <el-table-column prop="postingTime" label="发贴时间" width="100" align="center">
            <template slot-scope="scope">
              <div>
                {{ Common.dateFormatter(scope.row.postingTime, "yyyy-MM-dd") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="发贴人" width="200"  align="center"/>
          <el-table-column prop="title" label="标题">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="small" @click="details(scope.row)">
                  {{ scope.row.title }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pstSource" label="舆情来源" width="120" align="center">
            <template slot-scope="scope">
              <div>
                <a :href="scope.row.pstUrl" target="_blank">{{
                  scope.row.pstSource
                }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.status === 0
                    ? 'primary'
                    : scope.row.status === 4
                    ? 'success'
                    : 'warning'
                "
                disable-transitions
                >{{ scope.row.isSucces == false ? "已保存" : "已提交" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="status" width="120" fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.isSucces == false"
                type="text"
                size="small"
                @click="editNegative(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-if="scope.row.isSucces == false"
                @click="deleteRow(scope.row)"
                type="text"
                size="small"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="cust_pagin">
          <el-pagination
            layout="prev, pager, next"
            :total="xpagination.totalCount"
            :page-size="xpagination.pageSize"
            :current-page="xpagination.pageNumber"
            @current-change="handleCurrentChange"
            hide-on-single-page
            :background="true"
          />
        </div>
      </div>
    </el-main>
  </el-container>
</template>
  
<script>
import { Loading } from "element-ui";
export default {
  created() {
    this.pstApi.setWindowTitle("舆情上报");
    this.getPstList(); //读取分页信息
  },
  data() {
    return {
      //数据项
      data: {
        units: [], //单位数据
        psts: [], //舆情信息
      },
      //搜索栏数据
      query: {
        pstType: 1, //类别
        category: -2, //状态
        queryString: "", //模糊字段
      },
      //分页栏数据
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        pageNumber: 1,
        totalPages: 1,
      },
    };
  },
  methods: {
    //查询方法部分
    querySubmit() {
      this.getPstList();
    },
    getPstList() {

      this.pstApi
        .getNegativeList(
          this.query.category,
          this.query.queryString,
          this.xpagination.pageNumber,
          this.xpagination.pageSize
        )
        .then((res) => {
          var data = res.data;
          this.data.psts = data;
          // console.log(data);
          var pagin = JSON.parse(res.headers.xpagination);
          // console.log(pagin)
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch(() => {
          this.$toast("读取失败");
        });
    },
    //分页操作
    handleCurrentChange(val) {
      this.xpagination.pageNumber = val;
      this.getPstList();
    },
    addNegative() {
      this.$router.push({ name: "Negative" });
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    details(pst) {
      // console.log(row)
      this.$router.push({ name: "NegativeDetail", params: { id: pst.id } });
    },
    editNegative(pst) {
      if (pst.status == -2) {
        // console.log("editnegative")
        this.$router.push({ name: "EditNegative", params: { id: pst.id } });
      }
    },
    //删除
    deleteRow(pst) {
      if (pst.status < 0) {
        this.$confirm("确定要删除此条记录吗?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.pstApi
              .deleteNegative(pst.id)
              .then((res) => {
                this.$toast("删除成功");
                this.getPstList();
              })
              .catch((err) => {
                var message = err.response.data.Message;
                if (message == null) {
                  message = "删除失败";
                }
                this.$toast(message);
              });
          })
          .catch(() => {
            // row.status = row.status === 0 ? 1 : 0;
            // console.log("取消");
          });
      }
    },
  },
};
</script>
  
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
</style>